(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-feature-tab"] && !Shopify.designMode) return;
  try {
    

const highlightContainers = document.querySelectorAll('.content-highlight');
highlightContainers.forEach(highlightContainer => {
  const sectionEl = highlightContainer.closest('[id^="content-highlight-"]');
  const sectionId = sectionEl ? sectionEl.id.replace('content-highlight-', '') : '';
  const buttons = highlightContainer.querySelectorAll('.content-highlight__item');
  const images = highlightContainer.querySelectorAll('.content-highlight__image');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-highlight');
      
      // Update buttons
      buttons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      
      // Update images - include section ID in the target
      images.forEach(img => {
        img.classList.remove('active');
      });
      const targetImage = document.getElementById('highlight-' + sectionId + '-' + targetId);
      if (targetImage) {
        targetImage.classList.add('active');
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    

const tabsContainer = document.querySelector('.tabs');
const tabNav = tabsContainer.querySelector('.tab-nav');
const tabContent = tabsContainer.querySelector('.tab-content');
const tabPanels = tabContent.children;

// Create buttons for each tab panel
Array.from(tabPanels).forEach((panel, index) => {
  const id = panel.id || `tab-${index}`;
  console.log('panel' , panel);
  const title = panel.getAttribute('data-title') || `Tab ${index + 1}`;
  
  // Ensure panel has an id
  if (!panel.id) {
    panel.id = id;
  }

  // Create button
  const button = document.createElement('button');
  button.textContent = title;
  button.classList.add('button-secondary');
  button.setAttribute('data-tab', id);
  
  // Make first tab active by default
  if (index === 0) {
    button.classList.add('active');
    panel.classList.add('active');
  }
  
  // Add click handler
  button.addEventListener('click', function() {
    // Remove active from all buttons and panels
    tabNav.querySelectorAll('.tab-nav button').forEach(btn => btn.classList.remove('active'));
    Array.from(tabPanels).forEach(p => p.classList.remove('active'));
    
    // Add active to clicked button and corresponding panel
    this.classList.add('active');
    document.getElementById(id).classList.add('active');
  });
  
  tabNav.appendChild(button);
});


  } catch(e) { console.error(e); }
})();
})();
